<template>
  <svg :viewBox="viewBox" class="svg-content" :style='cssVars'>
    <rect class="background" @click="hideToolTip" :height="height" :width="width" fill="#fff" />
    <PlotAxis :margin="margin" :width="width" :height="height" :xScale="xScale" :yScale="yScale" />
    <line class="domain"
      :x1="margin.left"
      :x2="width - margin.right"
      :y1="height / 2"
      :y2="height / 2"
      stroke="#333"
      stroke-width="2"
    />
    <line
      class="domain"
      :x1="width / 2"
      :x2="width / 2"
      :y1="margin.top"
      :y2="height - margin.bottom"
      stroke="#333"
      stroke-width="2"
    />
    <ScatterPlot
      :margin="margin"
      :width="width"
      :height="height"
      :xScale="xScale"
      :yScale="yScale"
      :selected="selected"
      :filteredRegion="region"
      :showOutliers="showOutliers"
      v-if="showScatter"
      @selected="showToolTip"
    />
    <transition name="fade">
      <PartyScatter
        :margin="margin"
        :width="width"
        :height="height"
        :xScale="xScale"
        :yScale="yScale"
        :compare="compare"
        v-if="showParties"
      />
    </transition>
  </svg>
  <ToolTip
    v-if="selected"
    :item="selected"
    :x="toolTipX"
    :y="toolTipY"
  />
</template>

<script>
import { scaleLinear } from 'd3-scale';

import ScatterPlot from './ScatterPlot.vue'
import PartyScatter from './PartyScatter.vue'
import PlotAxis from './PlotAxis.vue'
import ToolTip from './ToolTip.vue'

export default {
  name: 'SvgWrapper',
  components: {
    PartyScatter,
    PlotAxis,
    ScatterPlot,
    ToolTip,
  },
  props: {
    options: Object,
    region: String,
    innerHeight: {
      type: Number,
      required: true,
      default: 800
    }
  },
  data() {
    const viewportHeight = this.innerHeight;
    return {
      viewportHeight,
      xScale: null,
      yScale: null,
      width: 500,
      height: 500,
      margin: {
        top: 80,
        right: 80,
        bottom: 80,
        left: 80,
      },
      selected: null,
      showParties: true,
      showScatter: false,
      showOutliers: false,
      compare: false,
      toolTipX: null,
      toolTipY: null,
    }
  },
  computed: {
    /* Variables you want to pass to CSS */
    cssVars () {
      return {
        '--viewportHeight': this.viewportHeight * 0.9 + 'px',
        '--marginBottom': this.viewportHeight * 0.05 + 'px'
      }
    },
    viewBox() {
      return `0 0 ${this.width} ${this.height}`;
    },
  },
  watch: {
    options(newOptions) {
      this.updateState(newOptions);
    },
  },
  created() {
    this.xScale = scaleLinear()
      .range([this.margin.left, this.width - this.margin.right])
      .domain([1, 7]);

    this.yScale = scaleLinear()
      .range([this.height - this.margin.bottom, this.margin.top])
      .domain([1, 7]);
  },
  mounted() {
  },
  unmounted() {
    window.removeEventListener('scroll', this.hideToolTip);
  },
  methods: {
    updateState(options) {
      const { showParties, showCompare, showScatter, showOutliers, region } = options;

      this.showParties = showParties || false;
      this.showScatter = showScatter || false;
      this.showOutliers = showOutliers || false;
      this.compare = showCompare || false;

      if (region !== undefined) {
        //
      }
    },
    showToolTip(data) {
      this.selected = data.item;
      this.toolTipX = data.mouseX;
      this.toolTipY = data.mouseY;

      window.addEventListener('scroll', this.hideToolTip);
    },
    hideToolTip() {
      this.selected = null;

      window.removeEventListener('scroll', this.hideToolTip);
    },
  },
}
</script>

<style lang="scss">
.svg-content {
  max-width: 700px;
  height: auto;
  // max-height: var(--viewportHeight);
  max-height: 90vh;
  display: block;
  margin: 0 auto;
  // margin-bottom: var(--marginBottom);
  margin-bottom: 5vh;
  font-family: 'Open Sans', Arial, sans-serif;
  
  .legend text {
    font-size: 18px;
  }

  text {
    fill: #222;
  }

  .intro-text {
    font-size: 14px;
  }

  .tool-description {
    font-size: 12px;
  }
}
</style>